/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
// utils
import { url } from 'utils/urls'
// material
import ArticleCard from 'material/articlecard/articleccard'
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as RightArrow } from 'assets/icons/right-arrow.svg'
// content
import PreviewConfig from 'material/previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './themepreview_styles'
import Space from 'material/space/space'
import { themePreview } from 'utils/consts/language'
import { useSelector } from 'react-redux'

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : THEME PREVIEW ~~~~~~~~~~ ========== */
const ThemePreview = injectSheet(styles)((props) => {
  const { siteTheme } = props
  const { generalConfig } = useSelector(state => state.trendingNowV2.tempTrendingNowConfig)
  
  const themePreviewLanguage = themePreview[siteTheme.language || 'EN']
  
  return (
    <div className={`themepreview ${props.classes.themepreview}`}>
      <PreviewConfig title={'Theme Preview'}>
        <Space gap={16} direction={'column'}> 
          <h3>{generalConfig.headerTitle}</h3>
            <ArticleCard 
              featured
              totalComments={53}
              totalReactions={'1.7k'}
              totalViews={'1.1k'}
              title={themePreviewLanguage.sampleTitle} 
              direction={'horizontal'}
              imageSrc={`${url.image}/2.0/trendingnow/article-image-1.jpg`}
              viewsLabel={themePreviewLanguage.views}
            />
          <Space alignItems={'center'} gap={0}>
          <div className='arrowwrap'><LeftArrow width={34} height={34} className='leftarrow' /></div>
          <div className='container'>  
            <ArticleCard 
              title={themePreviewLanguage.sampleTitle} 
              imageSrc={`${url.image}/2.0/trendingnow/article-image-2.jpg`}
              totalComments={30}
              totalReactions={100}
              totalViews={100}
              viewsLabel={themePreviewLanguage.views}
            />
            <ArticleCard 
              title={themePreviewLanguage.sampleTitle} 
              imageSrc={`${url.image}/2.0/trendingnow/article-image-3.jpg`}
              totalComments={22}
              totalReactions={49}
              totalViews={92}
              viewsLabel={themePreviewLanguage.views}
            />
            <ArticleCard 
              title={themePreviewLanguage.sampleTitle} 
              imageSrc={`${url.image}/2.0/trendingnow/article-image-4.jpg`}
              totalComments={14}
              totalReactions={23}
              totalViews={40}
              viewsLabel={themePreviewLanguage.views}
            />
          </div>
          <div className='arrowwrap'><RightArrow width={34} height={34} className='rightarrow' /></div>
          </Space>
        </Space>
      </PreviewConfig>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ThemePreview